import {
  Dispatch,
  SetStateAction,
  useState,
  createContext,
  useContext,
  ReactNode
} from 'react'

import { useParams } from 'react-router-dom'

import {
  useGetPedido
} from '@/hooks/queries/use-get-pedidos'
import { IDetalhePedido } from '@/interfaces/detalhe-pedido'

interface IDetalhePedidoProps {
  isEnabled: boolean
  isLoadingPedido: boolean
  setIsEnabled: Dispatch<SetStateAction<boolean>>
  pedido: IDetalhePedido | undefined
  page: number
  setPage: Dispatch<SetStateAction<number>>
  detailPage: number
  setDetailPage: Dispatch<SetStateAction<number>>
  selectedItemId: string | undefined
  setSelectedItemId: Dispatch<SetStateAction<string | undefined>>
  operadoraId: string
  setOperadoraId: Dispatch<SetStateAction<string>>
}

const DetalhePedidoContext = createContext<IDetalhePedidoProps | undefined>(
  undefined
)

const DetalhePedidoProvider = ({ children }: { children: ReactNode }) => {
  const { id } = useParams()
  const [page, setPage] = useState<number>(1)
  const [detailPage, setDetailPage] = useState<number>(1)
  const [isEnabled, setIsEnabled] = useState<boolean>(false)
  const [selectedItemId, setSelectedItemId] = useState<string | undefined>(
    undefined
  )
  const [operadoraId, setOperadoraId] = useState<string>()

  const {
    data: pedido,
    isLoading: isLoadingPedido
  } = useGetPedido({
    pedidoId: String(id)
  })

  return (
    <DetalhePedidoContext.Provider
      value={{
        isLoadingPedido,
        isEnabled,
        setIsEnabled,
        page,
        setPage,
        selectedItemId,
        setSelectedItemId,
        pedido,
        detailPage,
        setDetailPage,
        operadoraId,
        setOperadoraId
      }}
    >
      {children}
    </DetalhePedidoContext.Provider>
  )
}

const useDetalhePedidoContext = () => {
  const context = useContext(DetalhePedidoContext)
  if (context === undefined) {
    throw new Error(
      'useDetalhePedidoContext must be used within a DetalhePedidoProvider'
    )
  }
  return context
}

export { DetalhePedidoProvider, useDetalhePedidoContext }
